import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import { authToken } from '../config';
import { _route } from './sg';
import { forEach } from 'lodash';

export const logoutUser = () => {
  if (authToken) {
    return (
      <Paper
        style={{
          width: '60%',
          margin: '200px auto',
          padding: '50px',
          textAlign: 'center',
          color: 'red',
        }}
      >
        <Typography variant="h3"> Auth token expired. Not logged in. </Typography>
      </Paper>
    );
  }
  window.location.replace(`/logout`);
};

export const getRealmByUrl = (url) => {
  const [realm] = url.replace(/^\//, '').split('/');
  return realm;
};

export const redirectToGrowz = () => <Redirect to={_route('growz')} />;

export const getActiveTabFromUrl = (location, tabs) => {
  const { hash } = location;
  if (!hash) return 0;
  const name = hash.replace('#', '');
  return tabs.findIndex((i) => i?.key === name);
};

export const replaceQueryParams = (history, params, replace = false) => {
  const { search, hash } = history.location;
  const newSearchParams = new URLSearchParams(search);
  forEach(params, (value, key) => {
    newSearchParams.set(key, value);
  });
  const newSearch = `?${newSearchParams.toString()}${hash}`;

  if (replace) {
    history.replace(newSearch);
  } else {
    history.push(newSearch);
  }
};

export const replaceHashParam = (history, param) => {
  const { search } = history.location;
  const newSearch = `${search}#${param}`;

  history.push(newSearch);
};
